import {COMMAND} from "./mapConstants";

export const FIELD_TYPE = {
    SELECT: "select",       // <select> vracející string (enum hodnoty jako "left"/"normally_open"...)
    BOOL_SELECT: "boolSelect", // <select> se dvěma volbami, na výstupu skutečný boolean
    NUMBER: "number",
    TEXT: "text",
    CHECKBOX: "checkbox",   // na výstupu vždy boolean, i false — nikdy se nevynechává
    DATETIME: "datetime",   // <input type="datetime-local">, na výstupu ISO_OFFSET_DATE_TIME
};

const DIRECTION_OPTIONS = [
    {value: "", label: "— (výchozí)"},
    {value: "left", label: "Vlevo"},
    {value: "right", label: "Vpravo"},
];

const machineNumberField = {
    name: "machineNumber", label: "Číslo desky", type: FIELD_TYPE.NUMBER, placeholder: "0 = broadcast",
};

/**
 * Konfigurace formulářů pro payload příkazů TICKET_VALIDATOR_SOCKET turniketů.
 * Příkaz bez klíče zde = žádný modal, `TurnstileActionPanel` ho odešle rovnou s `{}`
 * (Stav desky, Info o zařízení, Vynutit sync — bezpečné dotazy bez rizika).
 */
export const COMMAND_FORM = {
    [COMMAND.OPEN]: {
        fields: [
            {name: "direction", label: "Směr", type: FIELD_TYPE.SELECT, options: DIRECTION_OPTIONS},
            {
                name: "count", label: "Počet", type: FIELD_TYPE.NUMBER, default: 1,
                showWhen: (values) => !!values.direction,
            },
            machineNumberField,
        ],
    },
    [COMMAND.BLOCK]: {
        fields: [
            {
                name: "blocked", label: "Stav", type: FIELD_TYPE.BOOL_SELECT, required: true,
                options: [
                    {value: "", label: "— vyberte —"},
                    {value: "true", label: "Zablokovat"},
                    {value: "false", label: "Odblokovat"},
                ],
            },
            {name: "direction", label: "Směr", type: FIELD_TYPE.SELECT, options: DIRECTION_OPTIONS},
            machineNumberField,
        ],
    },
    [COMMAND.REBOOT]: {
        fields: [],
        dangerous: true,
        confirmText: "Opravdu restartovat zařízení?",
    },
    [COMMAND.DISPLAY]: {
        fields: [
            {name: "text", label: "Text", type: FIELD_TYPE.TEXT, required: true},
            {name: "durationMs", label: "Doba zobrazení (ms)", type: FIELD_TYPE.NUMBER, default: 5000},
        ],
    },
    [COMMAND.RESTART_BOARD]: {
        fields: [machineNumberField],
        dangerous: true,
        confirmText: "Opravdu restartovat řídicí desku turniketu?",
    },
    [COMMAND.RESET_COUNT]: {
        fields: [
            {name: "direction", label: "Směr", type: FIELD_TYPE.SELECT, options: DIRECTION_OPTIONS},
            machineNumberField,
        ],
        dangerous: true,
        confirmText: "Opravdu vynulovat počítadla průchodů na desce? Původní hodnoty nelze obnovit.",
    },
    [COMMAND.FREE_PASSAGE]: {
        fields: [
            {
                name: "mode", label: "Režim", type: FIELD_TYPE.SELECT, required: true,
                options: [
                    {value: "", label: "— vyberte —"},
                    {value: "normally_open", label: "Trvale otevřeno"},
                    {value: "free", label: "Volný průchod"},
                    {value: "off", label: "Vypnuto"},
                ],
            },
            {name: "direction", label: "Směr", type: FIELD_TYPE.SELECT, options: DIRECTION_OPTIONS},
            machineNumberField,
        ],
        note: "Režim „Volný průchod“ (free) se na desce projeví až po restartu desky.",
    },
    [COMMAND.READERS]: {
        fields: [
            {name: "qr", label: "QR čtečka", type: FIELD_TYPE.CHECKBOX},
            {name: "nfc", label: "NFC čtečka", type: FIELD_TYPE.CHECKBOX},
        ],
    },
    [COMMAND.LED]: {
        fields: [
            {
                name: "ledType", label: "Typ LED", type: FIELD_TYPE.SELECT, required: true, asNumber: true,
                options: [
                    {value: "", label: "— vyberte —"},
                    {value: "1", label: "Typ 1"}, {value: "2", label: "Typ 2"}, {value: "3", label: "Typ 3"},
                    {value: "4", label: "Typ 4"}, {value: "5", label: "Typ 5"},
                ],
            },
            {
                name: "color", label: "Barva", type: FIELD_TYPE.SELECT, required: true,
                options: [
                    {value: "", label: "— vyberte —"},
                    {value: "WHITE", label: "Bílá"}, {value: "RED", label: "Červená"},
                    {value: "GREEN", label: "Zelená"}, {value: "BLUE", label: "Modrá"},
                    {value: "YELLOW", label: "Žlutá"}, {value: "ORANGE", label: "Oranžová"},
                ],
            },
            {name: "durationSec", label: "Doba svícení (s)", type: FIELD_TYPE.NUMBER, default: 0},
        ],
    },
    [COMMAND.SEMAPHORE]: {
        fields: [
            {
                name: "mode", label: "Režim", type: FIELD_TYPE.SELECT, required: true,
                options: [
                    {value: "", label: "— vyberte —"},
                    {value: "light", label: "Svit"}, {value: "flash", label: "Blikání"},
                ],
            },
        ],
    },
    [COMMAND.SET_TIME]: {
        fields: [
            {name: "time", label: "Čas", type: FIELD_TYPE.DATETIME},
        ],
        note: "Prázdné pole = použije se aktuální čas serveru.",
    },
    [COMMAND.UI]: {
        fields: [
            {name: "statusBar", label: "Status bar", type: FIELD_TYPE.CHECKBOX},
            {name: "navigationBar", label: "Navigation bar", type: FIELD_TYPE.CHECKBOX},
        ],
    },
    [COMMAND.SHUTDOWN]: {
        fields: [],
        dangerous: true,
        confirmText: "Zařízení se vypne a samo se nevrátí online. Opravdu pokračovat?",
        fixedPayload: {confirm: true},
    },
};

/** True, pokud má příkaz formulář (payload a/nebo potvrzení) — jinak se odešle rovnou. */
export function hasCommandForm(code) {
    return !!COMMAND_FORM[code];
}

/** Pole viditelná při aktuálních hodnotách (respektuje `showWhen`). `fields` může chybět. */
export function visibleFields(fields, values) {
    return (fields || []).filter((f) => !f.showWhen || f.showWhen(values));
}

/** Výchozí hodnoty formuláře — checkbox `false`, ostatní `default` (jako string) nebo `""`. `fields` může chybět. */
export function buildDefaultValues(fields) {
    const values = {};
    (fields || []).forEach((f) => {
        values[f.name] = f.type === FIELD_TYPE.CHECKBOX ? false : (f.default != null ? String(f.default) : "");
    });
    return values;
}

/** Povinná viditelná pole musí být vyplněná (checkbox je vždy platný — posílá se i `false`). */
export function isFormValid(config, values) {
    return visibleFields(config.fields, values).every((f) => {
        if (!f.required || f.type === FIELD_TYPE.CHECKBOX) return true;
        return values[f.name] !== "" && values[f.name] != null;
    });
}

/** "2026-08-20T14:30" (datetime-local, bez sekund/offsetu) → ISO_OFFSET_DATE_TIME pro backend. */
export function toIsoOffset(localDateTime) {
    const withSeconds = localDateTime.length === 16 ? localDateTime + ":00" : localDateTime;
    const d = new Date(localDateTime);
    const pad = (n) => String(n).padStart(2, "0");
    const offsetMin = -d.getTimezoneOffset();
    const sign = offsetMin >= 0 ? "+" : "-";
    const abs = Math.abs(offsetMin);
    return withSeconds + sign + pad(Math.floor(abs / 60)) + ":" + pad(abs % 60);
}

/**
 * Sestaví payload z hodnot formuláře. Nevyplněné (`""`/`null`) pole se vynechá —
 * backend si doplní vlastní default. Checkbox jde vždy (i `false`). `asNumber`
 * konvertuje na skutečné JSON číslo bez ohledu na to, že je pole renderované jako select
 * (backend `readInt()` odmítne stringové "2" jako neplatné).
 */
export function buildPayload(config, values) {
    const payload = {};
    visibleFields(config.fields, values).forEach((f) => {
        const raw = values[f.name];
        if (f.type === FIELD_TYPE.CHECKBOX) { payload[f.name] = !!raw; return; }
        if (raw === "" || raw == null) return;
        if (f.type === FIELD_TYPE.NUMBER || f.asNumber) { payload[f.name] = Number(raw); return; }
        if (f.type === FIELD_TYPE.BOOL_SELECT) { payload[f.name] = raw === "true"; return; }
        if (f.type === FIELD_TYPE.DATETIME) { payload[f.name] = toIsoOffset(raw); return; }
        payload[f.name] = raw;
    });
    return {...payload, ...(config.fixedPayload || {})};
}
